var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":_vm.arc,"fill":_vm.familyData.family.color,"stroke":"none","opacity":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }